// @flow

import React from 'react';
import ReactTooltip from 'react-tooltip';
import './CustomerProductOrderButton.css';

export type Props = {
  isOrdered: boolean,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  enabled: boolean,
  showWarning: string | boolean,
};

const CustomerProductOrderButton = ({
  isOrdered,
  onSelectProduct,
  onRemoveProduct,
  enabled,
  showWarning,
}: Props) => (
  <div
    className="CustomerProductOrderButton"
    {...(
      !!showWarning
        ? {
          'data-tip': '',
          'data-for': 'order-warning-tip',
        }
        : {}
    )}>
    {!isOrdered &&
      <button
        type="button"
        className="expanded button secondary"
        disabled={!enabled}
        onClick={onSelectProduct}>
        Välj produkt
      </button>
    }
    {isOrdered &&
      <button
        type="button"
        className="expanded button success"
        onClick={onRemoveProduct}
        disabled={!enabled}>
        <i className="remove-icon fa fa-remove" /> Ta bort val
      </button>
    }
    {typeof showWarning === 'string' &&
      <ReactTooltip
        id="order-warning-tip"
        effect="solid">
        <span>{showWarning}</span>
      </ReactTooltip>
    }
  </div>
);

export default CustomerProductOrderButton;



// WEBPACK FOOTER //
// ./src/components/CustomerProductOrderButton/CustomerProductOrderButton.js